import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const TopHeadingContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  @media (max-width: 768px) {
    display: block;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 5px;
  width: 100%;
  justify-content: flex-end;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`;

export const TopButtonsContainer = styled.div`
  display: flex;
`;

export const Header = styled.h1`
  color: ${colors.fsDarkBlue};
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 42px;
  min-width: 220px;
`;

export const AnchorLink = styled.a`
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  text-decoration: none;
  color: ${colors.white};

  :hover {
    color: ${colors.fsCyan};
    text-decoration: none;
  }
`;

export const ITag = styled.i.attrs((props) => ({ className: props.className }))`
  padding-right: 4px;
  ${(props) =>
    props.usePadding &&
    css`
      padding: ${props.usePadding};
    `}

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
`;

export const CompanyAndDepartmentDropDownContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 5px;
  max-width: 100%;
  margin-right: 15px;
`;
